<div class="pto-project-health-main-container">
  <div class="project-health-title-and-filter-container">
    <span class="project-health-title">Projects Health</span>
    <div class="project-health-filter-dropdown"></div>
  </div>
  <div class="project-health-data-container"></div>
</div>
